const en = {
  meta: { brand: "Ink & Ledger" },
  nav: { cv: "Download CV" },
  landing: {
    title: "Ruiting Zou",
    tagline: "Accounting & Finance Professional · LSE MSc Candidate",
    credential: "LSE MSc Accounting Fresh Graduate",
    badge: "Available now",
    hint: "Click a folder to explore",
    folders: { about: "About Me", projects: "Projects", journey: "Education & Experience", travel: "Travel", contact: "Contact", social: "Media & Reach" },
  },
  social: {
    cards: [
      {
        title: "CCTV Chinese Poetry Competition · Season 5, Episode 4",
        tag: "Television · Starts at 1:31:30",
        img: "/img/social1.jpg",
        link: "https://www.youtube.com/watch?v=7BAMZYjdZYo&t=5490s",
        caption: "Outstanding Contestant representing Shenzhen. Covered by People's Daily.",
        stats: [{ v: "100M+", l: "Viewers" }],
        play: true,
        pills: [
          { label: "YouTube", link: "https://www.youtube.com/watch?v=7BAMZYjdZYo&t=5490s" },
          { label: "Bilibili", link: "https://www.bilibili.com/video/BV1w64y127Kv?p=41&t=5490" },
        ],
      },
      {
        title: "Redesigning London's Oyster Transit Card",
        tag: "Media & Reach · RedNote (小红书)",
        img: "/img/social2.jpg",
        link: "https://xhslink.cn/o/4sCESBvTEiz",
        caption: "RedNote (小红书) is China's Instagram, with 100M+ daily active users.",
        stats: [{ v: "330K+", l: "Views" }, { v: "12K+", l: "Likes" }, { v: "1,100+", l: "Saves" }],
        linkLabel: "View post on RedNote",
        imgPos: "center 35%",
      },
      {
        title: "Redesigning Paris's Navigo Transit Card",
        tag: "Media & Reach · RedNote (小红书)",
        img: "/img/social3.jpg",
        link: "https://xhslink.cn/o/AFtdyd0oDGQ",
        caption: "Original post on RedNote (小红书), China's Instagram.",
        stats: [{ v: "8.3K", l: "Views" }, { v: "536", l: "Likes" }, { v: "70+", l: "Saves" }],
        linkLabel: "View post on RedNote",
      },
      {
        title: "Four Years of Accounting, Shared",
        tag: "Media & Reach · RedNote (小红书)",
        img: "/img/rednote-coursework.webp",
        imgPos: "center 10%",
        link: "https://www.xiaohongshu.com/collection/item/689a186402f9000000000001?xhsshare=&appuid=60e7ad8f0000000001005101&apptime=1792601678&share_id=0032ebfa3fa741bfa98476b8fe2fe935&share_channel=copy_link",
        caption: "Original posts on RedNote (小红书), China's Instagram, guiding students through all four years of the Accounting degree, plus IELTS preparation and my independent master's application. Drawn from my experience as volunteer lead lecturer of Beijing Normal-Hong Kong Baptist University's Principles of Accounting open course.",
        stats: [{ v: "40K+", l: "Views" }, { v: "1,000+", l: "Likes" }, { v: "600+", l: "Saves" }],
        linkLabel: "View post on RedNote",
      },
    ],
  },
  about: {
    label: "About",
    title: "Hello! I'm Ruiting ✋",
    italic: "Rigour of a ledger, warmth of a brushstroke.",
    paragraphs: [
      "I recently completed an MSc in Accounting, Organizations and Institutions at the London School of Economics, following a BBA in Accounting from Hong Kong Baptist University. I've also interned in audit at BDO and in trade accounting at China Electronics.",
      "If you stopped reading here, you might picture the classic accountant: head down, eyes on a calculator. That is one side of me, but far from the only one :) Finance and calligraphy or painting may look unrelated, yet I've kept both going through my undergraduate and master's years: they are my small points of light. I brought Chinese calligraphy and watercolor with me to London and opened an Etsy shop: a passion project rather than a profit centre, but every time someone discovers how charming they can be, that means far more than money.",
      "Finance and accounting is my profession, but it is not all of me: I have a heart that loves the humanities. That makes me empathetic, open-minded, a fast learner and a genuine team player.",
    ],
    closing: "Let's build something great together ✨",
    skillsLabel: "Skills & Expertise",
    skills: ["Audit & Assurance", "Financial Reporting", "Financial Modelling", "Excel (VBA)", "SQL & Python", "ERP", "Claude Code"],
    languagesLabel: "Languages",
    languages: ["Mandarin", "English", "Cantonese"],
  },
  projects: {
    label: "02 / Projects",
    title: "Where brushstrokes meet balance sheets.",
    intro: "Two self-initiated projects that show how I work: take an idea, own it end to end, and measure what matters.",
    featured: [
      {
        tag: "D2C E-Commerce",
        title: "Online London Etsy E-Commerce Studio",
        role: "Founder & Operator",
        year: "05/2026 - Present",
        link: "https://www.etsy.com/uk/shop/ZouneArtStudio",
        summary: "Built and operated a direct-to-consumer store selling hand-painted watercolor glass magnets, and ran it like a finance case study.",
        points: ["Modelled the full Etsy fee stack: transaction, payment processing, currency conversion, Offsite Ads, beyond the headline 6.5% rate", "Ran sensitivity and contribution-margin break-even analysis across FX rates, logistics and material costs", "Identified cross-border shipping as the leading driver of margin erosion"],
        metrics: [{ v: "Full", l: "Fee stack modelled" }, { v: "B/E", l: "Contribution-margin break-even" }, { v: "#1", l: "Margin driver: shipping" }],
        shop: { avatar: "/img/zoune-avatar.jpg", product: "/img/yellow-rose-magnet.webp", name: "ZouneArtStudio", location: "London, England", caption: "Yellow Rose Watercolor Fridge Magnet · £8.40" },
      },
      {
        tag: "Cultural Initiative",
        title: "London Chinese New Year Calligraphy Bookmark Project",
        role: "Independent Initiator · LSE",
        year: "02 - 03/2026",
        summary: "Independently crafted and delivered 100+ customised Chinese calligraphy bookmarks to students and professors across Europe, Asia and America, turning a Lunar New Year greeting into a cross-cultural conversation.",
        points: ["Independently designed, hand-crafted and delivered every bookmark", "Gathered each recipient's preferences through face-to-face conversation", "Reached students and professors across Europe, Asia and America"],
        metrics: [{ v: "100+", l: "Bookmarks delivered" }, { v: "3", l: "Continents reached" }, { v: "100%", l: "Positive feedback" }],
      },
    ],
    moreLabel: "More work",
    more: [
      { tag: "Project Leader · 09/2025 - 01/2026", title: "Tesco Accounting Information System Simulation", body: "Led a 6-member international team to model Tesco's supply chain with the REA framework and BPMN, building relational databases and advanced SQL for defect tracking and stock-out alerts, scored 80/100." },
      { tag: "Co-Author · Outstanding Thesis · 09/2024 - 07/2025", title: "Digital Transformation and Firm Performance in China", body: "Cleaned and structured 22,861 CSMAR samples with Python to build a six-dimensional digital transformation index, testing its impact on ROA and Tobin's Q with Stata and SPSS." },
    ],
  },
  journey: {
    label: "03 / Education & Experience",
    title: "A steady line, drawn with care.",
    eduLabel: "Education",
    expLabel: "Experience",
    edu: [
      { period: "09/2025 - 07/2026", school: "London School of Economics and Political Science", degree: "MSc Accounting, Organizations and Institutions", points: ["Coursework: Financial Reporting, Managerial Finance, Management Accounting, Corporate Financial Disclosure, Strategy & Control"] },
      { period: "09/2021 - 07/2025", school: "Hong Kong Baptist University", schoolSub: "Studied at Beijing Normal-Hong Kong Baptist University (Zhuhai, China)", degree: "BBA in Accounting (First Class Honours) · GPA 3.73 / 4.00 · Top 5%", points: ["Exempted from all 10 HKICPA Qualification Programme foundation modules", "Accounting Department Scholarship: First Prize 2021-22 & 2023-24 (Top 8%), Second Prize 2022-23 & 2024-25 (Top 20%)"] },
    ],
    exp: [
      { period: "07/2024 - 08/2024", org: "BDO China-SHU LUN PAN Certified Public Accountants LLP", role: "Audit Intern", points: ["Used Monetary Unit Sampling to select 100+ high-value vouchers and verify voucher-to-document consistency.", "Analysed revenue and gross margin schedules, flagging a 67.8% YoY revenue decline against a gross margin down only 1.52 percentage points.", "Completed client/bank confirmations and maintained a daily control table of 3,000+ entries for cross-ledger reconciliation."] },
      { period: "07/2023 - 09/2023", org: "China Electronics Shenzhen Company", role: "Accounting Intern", points: ["Reconciled core AR and AP balances to resolve discrepancies, and ran Excel ageing analysis to identify 180+ day slow-moving inventory.", "Managed multi-currency trade accounts and processed 1,200 vouchers across 9 categories, including bank receipts, payments and foreign exchange.", "Reviewed 1,000+ cross-border documents in ERP systems and tracked gross and net margin trends."] },
      { period: "02/2022 - 07/2025", org: "Beijing Normal-Hong Kong Baptist University · Zhuhai, China", role: "Volunteer Lead Lecturer, \"Principles of Accounting\" Open Course", points: ["Led volunteer open sessions (40+ hours) of Principles of Accounting, taught entirely in English, for 400+ students.", "Helped students from underdeveloped areas adapt to English-taught coursework through the open course.", "Rated 95% average satisfaction by 200+ students in end-of-term surveys across 3 consecutive semesters."] },
    ],
  },
  travel: {
    label: "04 / Travel",
    title: "17+ countries, one curious lens.",
    body: "Across Europe and the Middle East, including Israel and Palestine, travel has sharpened how I listen, adapt and work with people from every background.",
    count: "Countries explored",
    europe: "Europe",
    palestine: "Palestine",
    israel: "Israel",
  },
  contact: {
    label: "05 / Contact",
    title: "Let's build something that adds up.",
    body: "Open to audit, accounting and finance roles in Hong Kong. The fastest way to reach me is email or LinkedIn.",
    iang: "IANG holder: no visa sponsorship needed. Immediately available in Hong Kong.",
    copy: "Copy email",
    copied: "Email copied",
    form: { title: "Send a note", name: "Your name", email: "Email", org: "Organisation (optional)", message: "Message", send: "Send message", sending: "Sending…", success: "Thank you, your message has been received.", error: "Something went wrong. Please email me directly." },
  },
};
export default en;
